// components/MyResponses/MyResponsesBody.tsx
import React, { useState } from 'react';
import { Btn, H6, P } from '../../../AbstractElements';
import { format } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import { getUserSessionDetails } from '../../../services/common.service';

export default function ParticipantResponsesBody({ reviews, loading, error }: { reviews?: any[]; loading?: boolean; error?: string | null }) {
    const rows = reviews ?? [];
    const [expanded, setExpanded] = useState<Record<string, boolean>>({});
    const navigate = useNavigate();

    if (loading) {
        return (
            <tbody><tr><td colSpan={6}>Loading...</td></tr></tbody>
        );
    }
    if (error) {
        return <tbody><tr><td colSpan={6} style={{ color: 'red' }}>{error}</td></tr></tbody>;
    }
    if (rows.length === 0) {
        return <tbody><tr><td colSpan={6}>No submitted responses found.</td></tr></tbody>;
    }

    return (
        <tbody>
            {rows.map((r) => {
                const aid = r.assignment?._id ?? '';
                const assignmentTitle = r.assignment?.title ?? '—';
                const groupTitle = r.group?.title ?? '—';
                const templateTitle = r.template?.title ?? '—';
                const hasPre = Array.isArray(r.responses?.pre) && r.responses.pre.some((x: any) => x !== undefined && x !== null && String(x) !== '');
                const hasDuring = Array.isArray(r.responses?.during) && r.responses.during.some((x: any) => x !== undefined && x !== null && String(x) !== '');
                const hasPost = Array.isArray(r.responses?.post) && r.responses.post.some((x: any) => x !== undefined && x !== null && String(x) !== '');
                const summaryParts: string[] = [];
                if (hasPre) summaryParts.push(`Pre (${(r.responses?.pre || []).length})`);
                if (hasDuring) summaryParts.push(`During (${(r.responses?.during || []).length})`);
                if (hasPost) summaryParts.push(`Post (${(r.responses?.post || []).length})`);

                const submittedAt = r.submittedAt ? new Date(r.submittedAt) : null;

                return (
                    <React.Fragment key={r._id}>
                        <tr>
                            <td>
                                <div>
                                    <H6 className="mb-0">{assignmentTitle}</H6>
                                </div>
                            </td>
                            <td>{groupTitle}</td>
                            <td>{templateTitle}</td>
                            <td>{summaryParts.length ? summaryParts.join(' • ') : '—'}</td>
                            <td>{submittedAt ? format(submittedAt, 'yyyy-MM-dd HH:mm') : (r.lastSavedAt ? format(new Date(r.lastSavedAt), 'yyyy-MM-dd HH:mm') : '—')}</td>
                            <td className="text-end">
                                <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                                    <Btn color="outline" onClick={() => { navigate(`${process.env.PUBLIC_URL}/book_review/view/${r?.template?._id}?assignmentId=${r?.assignment?._id}&participantId=${getUserSessionDetails()?.id}`) }}>
                                        View
                                    </Btn>
                                </div>
                            </td>
                        </tr>

                        {expanded[r._id] && (
                            <tr>
                                <td colSpan={6}>
                                    <div style={{ padding: 12, borderRadius: 6 }}>
                                        <h6>Responses</h6>
                                        <div style={{ display: 'flex', gap: 18, flexWrap: 'wrap' }}>
                                            {['pre', 'during', 'post'].map(sec => {
                                                const arr = r.responses?.[sec] ?? [];
                                                if (!Array.isArray(arr) || arr.length === 0) return null;
                                                return (
                                                    <div key={sec} style={{ minWidth: 220 }}>
                                                        <strong style={{ textTransform: 'capitalize' }}>{sec}</strong>
                                                        <ul style={{ marginTop: 6 }}>
                                                            {arr.map((v: any, i: number) => <li key={i}><small>{typeof v === 'object' ? JSON.stringify(v) : String(v)}</small></li>)}
                                                        </ul>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                        {Array.isArray(r.duringNotes) && r.duringNotes.length > 0 && (
                                            <>
                                                <h6 className="mt-2">During Notes</h6>
                                                <ul>{r.duringNotes.map((d: any, idx: number) => <li key={idx}><small>{d.text}</small></li>)}</ul>
                                            </>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        )}
                    </React.Fragment>
                );
            })}
        </tbody>
    );
}
